'use client'

import { useQuery } from '@tanstack/react-query'
import services from '../services'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { GetProjectSearchParams } from '@/shared/api/end-points/project'
import { ProjectSearchResponse } from '../../lib'

type UseGetProjectSearchParams = GetProjectSearchParams & {
  enabled?: boolean
}

const defaultData: ProjectSearchResponse = {
  estimatedTotalHits: 0,
  limit: 20,
  offset: 0,
  query: null,
  entityType: null,
  hits: [],
}

const useGetProjectSearch = ({ enabled = true, ...params }: UseGetProjectSearchParams) => {
  const queryKey = [queryKeys((a, m) => a.project.getProjectSearch(params) + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.getProjectSearch(params)),
    enabled: Boolean(params.projectId) && enabled,
    refetchOnWindowFocus: false,
  })

  return {
    ...query,
    queryKey,
    data: query.data || defaultData,
  }
}

export default useGetProjectSearch
